// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"88b242ef","239":"89c666f9","455":"32fb7f5e"}[chunkId] + ".chunk.js";
};